import { IModel, IModelResponse } from '../../types/model';

export type TAddFeedbackModel = IModel<IAddFeedbackRequestSchema, TAddFeedbackResponseSchema>;

const defaultConfig: TAddFeedbackModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'userNotes',
  pathApi: '/v1/add-feedback/',
};

export function createAddFeedbackModel(config: Partial<TAddFeedbackModel>): TAddFeedbackModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface IAddFeedbackResponse200 extends IModelResponse<IAddFeedbackResponseSchema> {
  statusCode: 200;
}

export interface IAddFeedbackResponse400 extends IModelResponse<IAddFeedbackErrorResponseSchema> {
  statusCode: 400;
}

export type TAddFeedbackResponseSchema = IAddFeedbackResponse200 | IAddFeedbackResponse400;

export interface IAddFeedbackRequestSchema {
  offerId: number;
  comment: string;
}

export interface IAddFeedbackResponseSchema {
  status: 'ok';
}

export interface IAddFeedbackErrorResponseSchema {
  // tslint:disable-next-line:no-any
  errors: any[];
  message: string;
}
